// The words @foodamigos/ui's chat parts show or read out, which the package has in English only (their `labels`
// props, 0.3.0); usePlatformAgentLabels hands them to each part.
export default {
  composer: {
    send: 'Lähetä',
    stop: 'Pysäytä',
    attach: 'Liitä tiedostoja',
    add: 'Lisää',
    upload_files: 'Lataa tiedostoja',
  },
  attachment: {
    uploading: 'Ladataan {{percent}} %',
    uploading_file: 'Ladataan {{name}}',
    retry: 'Yritä uudelleen',
    remove: 'Poista {{name}}',
    cancel: 'Peruuta lataus: {{name}}',
  },
  // What screen readers hear for each step's state, and the collapsed list's line ("4 steps · 1 failed and was retried").
  steps: {
    pending: 'Odottaa',
    running: 'Käynnissä',
    done: 'Valmis',
    failed: 'Epäonnistui',
    denied: 'Hylätty',
    background: 'Taustalla',
    summary_one: '{{count}} vaihe',
    summary_other: '{{count}} vaihetta',
    failed_count_one: '{{count}} epäonnistui',
    failed_count_other: '{{count}} epäonnistui',
    retried_one: '{{count}} epäonnistui ja yritettiin uudelleen',
    retried_other: '{{count}} epäonnistui ja yritettiin uudelleen',
  },
  question: {
    suggested: 'Ehdotettu',
    withdrawn: 'Ei enää tarpeen',
  },
  thread: {
    live_on: 'Livenä osoitteessa {{domain}}',
    unread_one: '{{count}} uutta',
    unread_other: '{{count}} uutta',
    working: 'Työn alla',
  },
  // What screen readers hear for each row of a list that needs a look.
  checklist: {
    done: 'Valmis',
    running: 'Käynnissä',
    waiting: 'Vaatii huomiota',
    failed: 'Epäonnistui',
    pending: 'Ei vielä',
    skipped: 'Ohitettu',
  },
  lightbox: {
    enlarge: 'Suurenna: {{label}}',
    close: 'Sulje',
  },
};
